import { instance } from './axios.utils';
import { IImageTargetManifest } from './interface.utils';

export const compileFiles = async (
  files: File[],
  targetImageIds: string[],
  projectId: string,
  setProgress: (progress: number) => void,
  targetNames: string[] = [],
): Promise<IImageTargetManifest[]> => {
  if (files.length === 0) {
    throw new Error('No files provided to compile');
  }

  const formData = new FormData();
  files.forEach((file, i) => {
    formData.append('images', file);
    formData.append('ids', targetImageIds[i]);
    if (targetNames[i]) formData.append('names', targetNames[i]);
  });
  formData.append('project_id', projectId);

  const response = await instance().post('target/compile', formData, {
    onUploadProgress: (progressEvent: { loaded: number; total: number }) => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      setProgress(percent);
    },
  });

  return response.data.data.manifests;
};
